var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudModal',{attrs:{"title":_vm.$t('modals.company.billwerkConnectTitle'),"action":"update","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('BillwerkOrder',{attrs:{"change":"","create":"","order-data":_vm.orderData,"bookable-sales-plans":_vm.bookableSalesPlans}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }